import { module } from 'stereomodularjs';
import { createApp } from "vue/dist/vue.esm-bundler.js"
import ShowroomFilters from '../components/ShowroomFilters.vue'
import svgIco from '../components/svgIco.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;
        let makes = this.el.dataset.makes;
        const app = createApp({
            template: '<ShowroomFilters makesstr="' + makes + '" />',
            components: {
                ShowroomFilters,
                svgIco
            },
            data() {
                return {
                    spriteURL: self.el.dataset.sprite
                }
            }
        });
        app.component("svgIco", svgIco)
        app.config.globalProperties.cash = (value) => {
            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' $';
        }
        app.config.globalProperties.cents = (val) => {
            return parseFloat(val).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',') + ' $';
        }
        app.mount(self.el)

    }
}
